export default {
  jp: {
    title: 'パスワード再発行',
    label: {
      mailAddress: 'メールアドレス'
    },
    ph: {
      mailAddress: '登録メールアドレスを入力してください'
    },
    error: {
      mailAddress: {
        required: 'メールアドレスを入力してください。',
        maxLength: 'メールアドレスの入力内容に不備があります。',
        invalid: 'メールアドレスの書式に誤りがあります。'
      }
    },
    button: {
      change: 'パスワード再発行',
      back: '戻る'
    },
    desc: {
      text1: '登録メールアドレスに仮パスワードを発行して送信します。',
      text2: 'お手元にメールの到着後、メールに記載されたURLをクリックして仮パスワード変更画面へお進みください。'
    },
    desc2: {
      text1: '30分経っても登録メールアドレスにメールが届かない場合は、以下をご確認ください。',
      text2: '・フリーメールアドレスをご利用の場合は、迷惑メールフォルダやゴミ箱に振り分けられてしまうことがあります。そちらもご確認ください。',
      text3_1: '・携帯電話メールアドレスを使用されると、ドメイン設定によりメールが受信できない場合がございます。',
      text3_2: '「send-mediach@j-league.or.jp」',
      text3_3: 'を受信設定してください。'
    }
  },
  en: {
    title: 'Reissue Password',
    label: {
      mailAddress: 'Email Address'
    },
    ph: {
      mailAddress: 'Enter your email address.'
    },
    error: {
      mailAddress: {
        required: 'Please enter your email address.',
        invalid: 'Your email address is incorrect.',
        maxLength: 'Your email address is incorrect.'
      }
    },
    button: {
      change: 'Reissue Password',
      back: 'Back'
    },
    desc: {
      text1: 'A temporary password will be sent to your registered email address.',
      text2: 'Please click the URL in the email to change the temporary  password.'
    },
    desc2: {
      text1: 'Please check below if you do not receive an email within 30 minutes.',
      text2: '- Please check your spam/junk folder if you are using a free email account and cannot find the email.',
      text3_1: '- You may not be able to receive emails if you use a mobile phone due to domain settings. Please set to receive email from ',
      text3_2: '"send-mediach@j-league.or.jp"',
      text3_3: ''
    }
  }
}
